<template>
  <div class="content-contents container-fluid">
    <v-row class=" mb-2 mt-2">
      <v-col class="text-left">
        <naj-button
          icon="mdi-plus"
          @click="openNewComplaintPage"
        >
          {{ local.complaints.createNew }}
        </naj-button>
      </v-col>
    </v-row>
    <naj-box
      :title="local.common.complaintList"
      header-icon="mdi-format-list-bulleted-square"
      header-class="main-header"
      disable-collapsing
      has-footer
    >
      <naj-item-table
        :data-items="complaints || []"
        :headers="headers"
        :loading="loading"
        :enable-expand="true"
        :hide-default-no-data="true"
        @expandSlot="getComplaintDetails"
      >
        <template
          slot="caseNo"
          slot-scope="{item}"
        >
          <div
            class="info-item-details-title"
            :set="item.__value=item['caseNo']"
          >
            <span>{{ item.cRequestTypeName == 'تنفيذ'? local.complaints.headers.executionCode :local.complaints.headers.caseCode }}</span>
          </div>
          <div class="info-item-details-value">
            <span> {{ item.__value }}</span>
          </div>
        </template>
        <template slot="noData">
          <v-col class="text-center">
            <naj-archive-icon></naj-archive-icon>

            <p class="no-data-text">
              {{ local.complaints.noRequests }}
            </p>
          </v-col>
        </template>
        <template
          slot="expandSlot"
          slot-scope="{ item }"
        >
          <complaint-details
            v-if="selectedComplaint"
            :complaint="selectedComplaint"
          >
          </complaint-details>
        </template>
      </naj-item-table>
    </naj-box>
  </div>
</template>

<script>
import { complaintStatusIds } from '@/modules/complaints/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapComplaintsActions } = createNamespacedHelpers('ComplaintsModule');
import ComplaintDetails from './complaintDetails.vue';

export default {
  name: 'Home',
  components: { ComplaintDetails },
  props: {},
  data() {
    return {
      complaints: [],
      selectedComplaint: null,
      loading: false,
      userIdentityNumber: '',
      headers: [
        {
          value: 'number',
          text: this.local.complaints.headers.code,
        },
        {
          value: 'caseNo',
          text: this.local.complaints.headers.caseCode,
          isCustomTemplate: true,
        },
        {
          value: 'applyTypeName',
          text: this.local.complaints.complaintDetails.caseInfo.relation,
        },
        {
          value: 'sentDateH',
          text: this.local.complaints.headers.creationDate,
        },
        {
          value: 'stageName', //'statusName',
          text: null,
        },
      ],
      data: {},
    };
  },
  computed: {},
  watch: {
    selectedComplaint: {
      handler(newVal) {
        if (newVal && newVal.updateComplaint)
          this.getComplaint(newVal.cRequestID, newVal.number);
      },
      deep: true,
    },
  },
  mounted() { this.loadData(); },
  methods: {
    ...mapComplaintsActions([
      'getMyComplaintsRequests',
      'getComplaintData',
    ]),
    loadData() {
      this.loading = true;
      this.getMyComplaintsRequests()
        .then(({ data }) => {
          for (let i = 0; i < data.length; i++) {
            var cls = 'status-col ';
            if (data[i].stageId == complaintStatusIds.inprogress)
              cls = cls + 'status-inprogress';
            else if (data[i].stageId == complaintStatusIds.received)
              cls = cls + 'status-received';
            else if (data[i].stageId == complaintStatusIds.completed)
              cls = cls + 'status-completed';
            this.$set(data[i], 'class-stageName', cls);
          }
          this.complaints = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getComplaintDetails(item) {
      if (!this.selectedComplaint || this.selectedComplaint.cRequestID != item.cRequestID) {
        this.getComplaint(item.cRequestID, item.number);
      }
    },
    getComplaint(id, number) {
      this.loading = true;
      this.selectedComplaint = null;
      this.getComplaintData(id)
        .then(({ data }) => {
          (data.clarificationRequestList || []).forEach((element) => {
            element.viewMode = this.hasResponse(element);
          });
          this.selectedComplaint = {
            ...data,
            cRequestID: id,
            complaintNo: number,
            updateComplaint: false,
          };

          this.selectedComplaint.formDetails = null;
          if (this.isJson(data.details) || this.isJson(data.jsonDetails)) {
            var detailsStr = data.jsonDetails ? data.jsonDetails : data.details;
            var formJson = JSON.parse(detailsStr);
            if (typeof formJson === 'object') {
              this.selectedComplaint.formDetails = formJson;
            }

          }

        })
        .finally(() => {
          this.loading = false;
        });
    },
    isJson(str) {
      if (!str)
        return false;
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    openNewComplaintPage() {
      this.$router.push(`/complaint`);
    },
    hasResponse(item) {
      return item && item.responseList && item.responseList.length > 0 && ((item.responseList[0].responseText != '' && item.responseList[0].responseText != null)
        || (item.responseList[0].attachmentList && item.responseList[0].attachmentList.length > 0));
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .info-item-details-title:has(> .status-col) {
    display: none;
  }

  .status-col {
    justify-content: left;
    display: flex;
    align-items: center;

    span {
      padding: 0.25em 0.4em;
      font-size: 0.75em;
      font-weight: 700;
      border-radius: 4px;
      color: #fff;
      margin-top: 5px;
    }
    &.status-inprogress span {
      background-color: #6f5d2f;
    }

    &.status-completed span {
      background-color: #203f39;
    }
    &.status-received span {
      background-color: #50b197;
    }
  }

  .v-button-wrapper .naj-button.primary {
    margin: 0 !important;
  }
}
.content-contents.container-fluid {
  box-shadow: 0 0.75rem 6rem rgba(56, 65, 74, 0.03);
  margin-bottom: 1.5rem;
  background-color: #fff;
  background-clip: border-box;
  border: 0 solid #f7f7f7;
  border-radius: 0.25rem;
  padding: 0.75rem !important;
}
</style>
